import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ChartBox from '../../Custom/ChartBox';
import { act_GetPhasorInstantaneousData } from '../../../actions/EEReportAction';
import ChartLoader from '../../Loaders/ChartLoader';
import Auth from '../../../shared/Auth';

class LiveReadingsWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      InstantaneousData: [],
      loading: true,
    };
  }

  UNSAFE_componentWillMount() {
    this.fetchData(this.props.deviceId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId) {
      this.setState({
        loading: true,
      });
      this.fetchData(nextProps.deviceId);
    }
  }

  async fetchData(id) {
    const checkToken = await Auth();
    if (checkToken) {
      this.props
        .act_GetPhasorInstantaneousData(id)
        .then((res) => {
          if (res.payload.data.statusCode === 200) {
            this.setState({
              InstantaneousData: res.payload.data.result,
              loading: false,
            });
          } else {
            this.setState({ InstantaneousData: [], loading: false });
          }
        })
        .catch((errr) => {
          console.log(errr);
          this.setState({ InstantaneousData: [], loading: false });
        });
    }
  }

  render() {
    const { InstantaneousData, loading } = this.state;
    let lastFeedDateTime = 'Last Feed:';
    if (InstantaneousData.length > 0) {
      lastFeedDateTime = InstantaneousData.pop().parameter;
      // console.log('instantaneous data',InstantaneousData,lastFeedDateTime);
    }
    return (
      <p>
        <ChartBox title={'Live Readings'}>
          {loading ? (
            <ChartLoader height="150" width="600" />
          ) : (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>R</th>
                  <th>Y</th>
                  <th>B</th>
                  <th>DayMin</th>
                  <th>DayMax</th>
                </tr>
              </thead>
              <tbody>
                {InstantaneousData.length > 0 ? (
                  InstantaneousData.map((d, index) => (
                    <tr key={index}>
                      <td>{d.parameter}</td>
                      <td>{d.r}</td>
                      <td>{d.y}</td>
                      <td>{d.b}</td>
                      <td>{d.dayMin}</td>
                      <td>{d.dayMax}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </ChartBox>
        <b>{lastFeedDateTime.length > 20 ? lastFeedDateTime : ''}</b>{' '}
        {/* workaround safety check to prevent posting any other parameter */}
      </p>
    );
  }
}

export default connect(
  () => ({
    // eeReports: state.EEReportsReducer
  }),
  (dispatch) =>
    bindActionCreators(
      {
        act_GetPhasorInstantaneousData,
      },
      dispatch
    )
)(LiveReadingsWidget);
